export enum SortBy {
    Id = 0,
    Device = 1,
    Creator = 2,
    Reporter = 3,
    Editor = 4,
    CreatedAt = 5,
    ArchivedAt = 6,
    ClosedAt = 7,
    UpdatedAt = 8,
    UserName = 9,
    MandantName = 10,
}
export enum SortByString {
    Id = "id",
    Device = "deviceId",
    Creator = "creator",
    Reporter = "lastEditor",
    CreatedAt = "createdDate",
    UpdatedAt = "updatedAt",
    ClearedAt = "clearedDate",
    Component = "component",
    Category= "category",

    Name = "name",
    Location = "location",
    IsOnline = "isonline",
    SoC = "soc",
    ActivePower = "activepower",

    UserName = "personName",
    MandantName = "mandantName",

    City = "city",
    PostCode = "postalCode",
    CountryCode = "countryCode",

    Charger = "charger",
    Power = "power",
    Capacity = "capacity",


    Locations = "locations",
    Mandant = "mandant",
    Type = "type",

    LastOnline = "lastonline",
    Commissioning = "commissioning",
    Month = "month",
    Sum = "sum",
    FirstReceived = "firstReceived",
}
export enum SortOrder {

    Ascending = "Ascending",
    Descending = "Descending",
}

export enum SortOrderbyNumber {
    Ascending = 0,
    Descending = 1,
}
